import React from "react";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { history } from "./store";
import { store, persistor } from "./store";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import {
  Home,
  EstudarUA,
  PrepararViagem,
  VidaAcademica,
  CidadeAveiro,
  ChegadaAveiro,
  P404,
  ProcessoIntegracao,
  ToDoList,
  FAQ,
  ContactosEstruturas,
  ContactosEmergencia,
  ConstructionPage,
} from "./pages";
import { PersistGate } from "redux-persist/integration/react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

function App (props) {
  //const { isLogged } = props;

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ConnectedRouter history={history}></ConnectedRouter>
          <Router>
            <Navbar />
            <Switch>
              <Route exact path="/" component={Home} />
              <Route exact path="/estudarUA" component={EstudarUA} />
              <Route exact path="/cidadeaveiro" component={CidadeAveiro} />
              <Route exact path="/prepararviagem" component={PrepararViagem} />
              <Route exact path="/chegadaaveiro" component={ChegadaAveiro} />
              <Route
                exact
                path="/processointegracao"
                component={ProcessoIntegracao}
              />
              <Route exact path="/vidaacademica" component={VidaAcademica} />
              <Route exact path="/todolist" component={ToDoList} />
              
              <Route exact path="/faqs" component={FAQ} />
              <Route
                exact
                path="/contactosestruturas"
                component={ContactosEstruturas}
              />
              <Route
                exact
                path="/contactosemergencia"
                component={ContactosEmergencia}
              />
              <Route exact path="/construcao" component={ConstructionPage} />
              <Route component={P404} />
            </Switch>
            <Footer />
          </Router>
      </PersistGate>
    </Provider>
  );
}

export default App;
